var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComoros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M24-.003H0v3.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M24 4.003H0V8h24V4.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24 8H0v3.998h24V8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M12 8L0 16.003V-.003L12 8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M3.217 8A2.437 2.437 0 015.13 5.622a2.392 2.392 0 00-.525-.06 2.438 2.438 0 000 4.875c.177 0 .352-.02.525-.06A2.438 2.438 0 013.217 8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M5.1 5.915l.135.397h.42l-.345.248.135.397L5.1 6.71l-.338.247.135-.397-.345-.248h.42l.128-.397zm0 1.042l.135.398h.42l-.345.247.135.398-.345-.248L4.762 8l.135-.398-.345-.247h.42l.128-.398zM5.1 8l.135.397h.42l-.345.248.135.397-.345-.247-.338.247.135-.397-.345-.248h.42L5.1 8zm0 1.042l.135.398h.42l-.345.247.135.398-.345-.248-.338.248.135-.398-.345-.247h.42l.128-.398z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComoros);
export default __webpack_public_path__ + "static/media/Comoros.fe8ec672adef37b7205365662f5fc0e4.svg";
export { ForwardRef as ReactComponent };